import firstNewImage from '../images/poster/new/1-new.jpg'
import secondNewImage from '../images/poster/new/2-new.jpg'
import thirdNewImage from '../images/poster/new/3-new.jpg'
import fourthNewImage from '../images/poster/new/4-new.jpg'
import fifthNewImage from '../images/poster/new/5-new.jpg'
import firstTitleImage from '../images/poster/new_titles/1-new_titles.jpg'
import secondTitleImage from '../images/poster/new_titles/2-new_titles.jpg'
import thirdTitleImage from '../images/poster/new_titles/3-new_titles.jpg'
import fourthTitleImage from '../images/poster/new_titles/4-new_titles.jpg'
import fifthTitleImage from '../images/poster/new_titles/5-new_titles.jpg'
import firstOldImage from '../images/poster/old/1-old.jpg'
import secondOldImage from '../images/poster/old/2-old.jpg'
import thirdOldImage from '../images/poster/old/3-old.jpg'
import fourthOldImage from '../images/poster/old/4-old.jpg'
import fifthOldImage from '../images/poster/old/5-old.jpg'

export default () => {
	class Quiz {
		constructor(questions, results) {
			this.questions = questions
			this.possibleResults = results
			this.result = 0
			this.currentQuestionIndex = 0
			this.score = 0
		}

		calcCorrectIndex(index) {
			const isRightAnswer = this.questions[this.currentQuestionIndex].checkAnswer(index)
			this.score += +isRightAnswer
			const answers = this.questions[this.currentQuestionIndex].answers

			let correctIndex = null

			if (isRightAnswer) {
				correctIndex = index
			} else {
				answers.forEach((answer, idx) => {
					if (answer.right) {
						correctIndex = idx
					}
				})
			}

			this.nextQuestion()

			return correctIndex
		}

		nextQuestion() {
			this.currentQuestionIndex++
			if (this.currentQuestionIndex >= this.questions.length) {
				this.endQuiz()
			}
		}

		endQuiz() {
			for (let i = 0; i < this.possibleResults.length; i++) {
				if (this.possibleResults[i].check(this.score)) {
					this.result = i
				}
			}
		}
	}

	class Question {
		constructor(poster, answers) {
			this.imagesNode = `
				<img src="${poster[0].image}" class="head__image head__image_visible" /> 
				<img src="${poster[1].image}" class="head__image js-show" />
			`
			this.titlesNode = `
			<p class="head__title js-slide-down">${poster[0].title}</p>
			<p class="head__title js-slide-down">${poster[1].title}</p>
			`
			this.titleImage = poster[0].titleImage
			this.answers = answers
		}

		checkAnswer(index) {
			return this.answers[index].right
		}
	}

	class Answer {
		constructor(text, right = false) {
			this.text = text
			this.right = right
		}
	}

	class Result {
		constructor(text, value) {
			this.text = text
			this.value = value
		}
		check(checkingValue) {
			return this.value <= checkingValue
		}
	}

	const handleUpdate = () => {
		const buttonsContent = document.querySelector('.buttons__content')
		const socialShares = document.querySelector('.social-shares')
		const questions = quiz.questions
		const currentQuestion = questions[quiz.currentQuestionIndex]
		if (quiz.currentQuestionIndex < questions.length) {
			headImagesElem.innerHTML = currentQuestion.imagesNode
			headTitlesElem.innerHTML = currentQuestion.titlesNode
			buttonsElem.innerHTML = ''

			currentQuestion.answers.forEach((answer, idx) => {
				let btn = document.createElement('button')

				btn.className = 'button button_visible button-js'
				btn.innerHTML = answer.text
				btn.setAttribute('index', idx)

				buttonsElem.appendChild(btn)
			})

			pagesElem.innerHTML = quiz.currentQuestionIndex + 1 + ' / ' + questions.length

			handleInit()
		} else {
			buttonsElem.innerHTML = ''
			headTitlesElem.innerHTML = ''
			headImagesElem.innerHTML = quiz.possibleResults[quiz.result].text
			pagesElem.innerHTML = ''
			headImagesElem.style.minHeight = '0px'
			buttonsContent.style.width = '0px'
			buttonsContent.style.margin = '0px'
			socialShares.style.position = 'static'
			socialShares.style.transform = 'translateX(0%) translateY(0%)'
		}
	}

	const handleInit = () => {
		let btns = document.querySelectorAll('.button')

		btns.forEach((btn) => {
			btn.addEventListener('click', (e) => {
				handleClick(+e.target.getAttribute('index'))
			})
		})
	}

	const handleClick = (index) => {
		let btns = document.querySelectorAll('.button')

		document.querySelector('.head__image').classList.add('head__image_slide-left')
		document.querySelector('.js-show').classList.add('head__image_visible')
		document.querySelectorAll('.js-slide-down').forEach((title) => {
			title.classList.add('head__title_action')
		})

		document.querySelector('.head__image_slide-left').src = quiz.questions[quiz.currentQuestionIndex].titleImage

		let correctIndex = quiz.calcCorrectIndex(index)

		btns.forEach((btn) => {
			btn.className = 'button button_passive button_visible button-js'
			btn.disabled = true
		})

		index !== correctIndex
			? (btns[index].className = 'button button_wrong button_visible button-js')
			: (btns[index].className = 'button button_correct button_visible button-js')

		setTimeout(handleHideAnswers, 1200)
	}

	const handleHideAnswers = () => {
		let btns = document.querySelectorAll('.button')

		btns.forEach((btn, idx) => {
			switch (idx) {
				case 0:
					btn.className += ' button_slide-right'
					break
				case 2:
					btn.className += ' button_slide-left'
					break
				default:
			}
		})

		let newBtn = document.createElement('button')

		newBtn.className = 'button button_visible'
		newBtn.innerHTML = quiz.currentQuestionIndex === quiz.questions.length ? 'Закончить тест' : 'Следующий вопрос'
		newBtn.addEventListener('click', () => {
			handleUpdate()
		})

		setTimeout(() => {
			buttonsElem.innerHTML = ''
			buttonsElem.appendChild(newBtn)
		}, 400)
	}

	const results = [
		new Result(
			`<p class="quiz-result__text"><b class="quiz-result__header">Новичок</b><br/>
			Скорее всего, вы яркий поклонник современных фильмов, а не советской классики. Однако, нет повода для расстройств. Включайте новый киноканал “Мосфильм. Золотая коллекция” и скорее наверстывайте упущенное, погружаясь в невероятную атмосферу отечественного кинематографа.
		</p>`,
			0
		),
		new Result(
			`<p class="quiz-result__text"><b class="quiz-result__header">Любитель </b><br/>
			Ваш результат можно назвать отличным, хотя были небольшие неточности. Возможно, это прекрасный повод пересмотреть любимые советские фильмы на киноканале “Мосфильм. Золотая коллекция“, чтобы освежить в памяти некоторые эпизоды.
		</p>`,
			3
		),
		new Result(
			`<p class="quiz-result__text"><b class="quiz-result__header">Знаток</b><br/>
			Всего одна ошибка отделяет Вас от победы. Однако, это не повод расстраиваться! Наоборот - самое время устроить себе прекрасный вечер в компании любимых героев советского кино вместе с “Мосфильм. Золотая коллекция.“
			</p>`,
			4
		),
		new Result(
			`<p class="quiz-result__text"><b class="quiz-result__header">Эксперт</b><br/>
		Поздравляем! Вы истинный ценитель советского кино, который с легкостью может определить любимый фильм по завуалированной иллюстрации. Вы прекрасно ориентируетесь в отечественном кинематографе. Есть, с кого брать пример!
		</p>
		`,
			5
		),
	]

	const questions = [
		new Question(
			[
				{
					image: firstNewImage,
					titleImage: firstTitleImage,
					title: `<b>Тим Яржомбек:</b><br/>
				<i>«Я выбрал фильм «Афоня», так как являюсь большим поклонником Георгия Данелии! Из
				предложенного списка этот фильм меньше всего переосмысливали в иллюстрации.
				Незабываемые характеры, абсурдные «линчевские» сцены с оркестром и
				великолепный юмор. С огромным удовольствием пересмотрел его с семьей, и выбрал
				момент, где три разные локации вступают в связку между собой. Их удалось
				объединить центральной темой дома, микромира, в котором происходит часть
				фильма».</i><br/><br/>
				<b>Биография:</b> Тимофей Яржомбек с 2003 работает фриланс-иллюстратором, основное
				направление — периодические издания и книги. С каждым годом задачи становятся все
				более разнообразными. Больше всего любит работать с метафорой. С 2016 года
				работает куратором в школе дизайна НИУ ВШЭ. С 2020 — с агентством Bang! Bang!<br/>
				<b>Проекты для:</b> Esquire, «Секрет фирмы», РБК, Blueprint, «Большой город». Работал с
				издательствами «МИФ», «Белая ворона», «РОСМЕН», «Самокат», издательством студии
				Лебедева, с брендами «Яндекс. Драйв», «Сбербанк», «СитиМобил», Nutella, «Додо
				пицца» и др.`,
				},
				{
					image: firstOldImage,
					title: 'Оригинальный постер к фильму «Афоня», 1975.<br/> Источник: «Мосфильм»',
				},
			],
			[
				new Answer('«Добро пожаловать, или посторонним вход воспрещен»'),
				new Answer('«Афоня»', true),
				new Answer('«Джентльмены удачи»'),
			]
		),
		new Question(
			[
				{
					image: secondNewImage,
					titleImage: secondTitleImage,

					title: `
						<b>Андрей Тарусов:</b><br/> <i>«Мне всегда нравился профиль Ивана Васильевича и на картинах, и в кино.
						Особенно запомнился известный кадр с профилем царя из фильма Эйзенштейна. Этот мотив я и
						решил использовать для новой афиши «Иван Васильевич меняет профессию», только изобразить
						профиль комедийного царя с подвязанной челюстью. Он как бы находится в Москве 60-х, но также
						изображены мотивы из Руси прошлого. Этим я показал главный сюжет фильма о двух эпохах».</i><br/><br/>
						<b>Биография:</b> родился в Рыбинске, Закончил Художественное училище и ВГИК, долгое время жил в
						Лос-Анджелесе. <br/>
						<b>Проекты для:</b> Disney, FOX, Playboy, Maxim. Крупные проекты «Олимпийский
						календарь», Kinky Cards на Kickstartere.
						`,
				},
				{
					image: secondOldImage,
					title:
						'Оригинальный постер к фильму «Иван Васильевич меняет профессию», 1973. Источник: «Мосфильм»',
				},
			],
			[
				new Answer('«Иван Грозный»'),
				new Answer('«Иван Васильевич меняет профессию»', true),
				new Answer('«Цареубийца»'),
			]
		),
		new Question(
			[
				{
					image: thirdNewImage,
					titleImage: thirdTitleImage,
					title: `
						<b>Саша Байдин:</b><br/>
						<i>«Для меня фильм «Ирония судьбы, или С лёгким паром!» это, в первую очередь, сатира
						авторов на тему того, что в 60 - 70-е годы города по всему Советскому союзу города
						активно застраивались однотипными серийными домами, школами, универмагами и
						т.д. Новые типовые районы росли как грибы после дождя, обезличивания города.
						Попав в такой район невозможно понять, где ты — в Москве, Санкт-Петербурге или
						Новосибирске. Прошло почти полвека, а ситуация только усугубилась. Типовые
						панельки превратились в монструозные многоэтажки, а о благоустройстве дворов
						напрочь забыли, отчего ситуация уже не кажется забавной. В своем постере я
						попытался изобразить недоумение главного героя фильма, попавшего в современный
						спальный район на окраине».</i><br/><br/>
						<b>Биография:</b> Родом из маленького сибирского городка, но последние лет 15 живет и
						работает в Петербурге.<br/>
						<b>Проекты для:</b> Около 5 лет сотрудничает с агентством Bang!Bang! Рисовал для многих
						российских брендов, таких как: «Яндекс», «КиноПоиск», «СитиМобил», Joom,
						«Касперский», MoscowUrbanForum, «Архыз», «Балтика», «Эльдорадо», «Связной», МТС,
						РЖД, «Газпром» и др.`,
				},
				{
					image: thirdOldImage,
					title:
						'Оригинальный постер к фильму «Ирония судьбы, или С лёгким паром!», 1975. Источник: «Мосфильм»',
				},
			],
			[
				new Answer('«Вы мне писали»'),
				new Answer('«Осенний марафон»'),
				new Answer('«Ирония судьбы, или С лёгким паром!»', true),
			]
		),
		new Question(
			[
				{
					image: fourthNewImage,
					titleImage: fourthTitleImage,
					title: `
						<b>Вадим Ганненко:</b><br/>
						<i>«Посмотри на мир другими глазами, и мир станет другим». Я выбрал «Служебный
						роман» потому, что — это добрый, позитивный, немного наивный фильм, но...
						Мы, современники, привыкли прятаться за масками, а что там за маской зачастую не
						видим, да и не хотим. Узнать человека, раскрыть его истинное лицо, измениться и
						изменить свое отношение к нему в наш прагматичный, расчетливый век, не до того...
						а жаль! Фраза «если Вы еще способны плакать – значит не все потеряно» – это я
						попытался изобразить на новой афише к фильму. Проявление человечности у героини
						с ярлыком "мымра"».</i><br/><br/>
						<b>Биография:</b> закончил театрально-художественный колледж, факультет «иконопись» и
						ХГАДИ, факультет «графический дизайн».<br/>
						<b>Проекты для:</b> «Опендатабот», «Аудико», Poster, издательство «Манн, Иванов и Фербер»,
						«Растишка», ОЛХ, «Одноклассники», «Агуша», журнал «НАШ».
				`,
				},
				{
					image: fourthOldImage,
					title: 'Оригинальный постер к фильму «Служебный роман», 1977.<br/> Источник: «Мосфильм»',
				},
			],
			[
				new Answer('«Формула любви»'),
				new Answer('«Дамы приглашают кавалеров»'),
				new Answer('«Служебный роман»', true),
			]
		),
		new Question(
			[
				{
					image: fifthNewImage,
					titleImage: fifthTitleImage,
					title: `<b>Катя Мурысина:</b><br/>
				<i>«Постеры к старым фильмам рисовать очень интересно, потому что сквозь время
				ты видишь, какие сцены и персонажи запомнились и стали культовыми, а какие нет. И
				это возможно совсем не те герои, на которых делали ставку авторы. Свободная
				Москва 50-х, которую олицетворял неутомимый Савранский, и душевные декорации
				коммунальной квартиры — это то, что останется в душе у зрителя и через десятки
				лет, даже если он немного позабудет тонкости сюжета».</i><br/><br/>
				<b>Биография:</b> художник-иллюстратор из Санкт-Петербурга.<br/>
				<b>Проекты для:</b> начинала свою карьеру как концепт художник и дизайнер арт-объектов, с
				2018 года рисует вместе с агентством Bang! Bang! Рисовала для Adobe, Nike, LVMH,
				Студии Артемия Лебедева, L’Officiel, YSL Beauty и др.`,
				},
				{
					image: fifthOldImage,
					title: 'Оригинальный постер к фильму «Покровские ворота», 1982.<br/> Источник: «Мосфильм»',
				},
			],
			[
				new Answer('«Покровские ворота»', true),
				new Answer('«Приключения итальянцев в России»'),
				new Answer('«Берегись автомобиля»'),
			]
		),
	]

	const quiz = new Quiz(questions, results)

	document.querySelector('.quiz') ? handleUpdate() : null
}
